import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutTrustPage = lazy(() => import('../pages/about/trust/page'));
const AboutBeneficiariesPage = lazy(() => import('../pages/about/beneficiaries/page'));
const AboutTrusteesPage = lazy(() => import('../pages/about/trustees/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-700"></div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <HomePage />
      </Suspense>
    )
  },
  {
    path: '/about/trust',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <AboutTrustPage />
      </Suspense>
    )
  },
  {
    path: '/about/beneficiaries',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <AboutBeneficiariesPage />
      </Suspense>
    )
  },
  {
    path: '/about/trustees',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <AboutTrusteesPage />
      </Suspense>
    )
  },
  {
    path: '/projects',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <ProjectsPage />
      </Suspense>
    )
  },
  {
    path: '/contact',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <ContactPage />
      </Suspense>
    )
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <NotFoundPage />
      </Suspense>
    )
  }
];

export default routes;
